import React from 'react'
import {PanelWrapper} from "./PanelWrapper";
import useGetExhibits from "../../../hooks/api/useGetExhibits";
import {Card} from "../Card";
import {Exhibit} from "../../../types/Exhibit";
import {isSelected, loadingSkeleton} from '../EntitySelectorModal.helpers'
import {EmptyState} from "../EmptyState";
import {ENTITY_TYPES} from "../../EntitySelector/EntitySelector.constants";
import {type SelectedItemsData} from "../../EntitySelector/EntitySelector.types";

// Types ----

type ExhibitsPanelProps = {
  onSelect: (exhibit: Exhibit) => void
  selectedItems: SelectedItemsData
  siteId?: number | null
  isMaxSelected?: boolean
  isMultiSite?: boolean
}

// Component ----

function ExhibitsPanel({ onSelect, selectedItems, siteId, isMaxSelected, isMultiSite }: ExhibitsPanelProps) {
  const {data: exhibits, isLoading} = useGetExhibits({
    sites: siteId?.toString(),
    per_page: 1000,
    published: true,
  });

  return (
      <PanelWrapper isLoading={isLoading}>
        {isLoading ?
          loadingSkeleton :
          <>
            {!!exhibits?.data?.length ? exhibits?.data.map(exhibit => {
                const selected = isSelected(exhibit, ENTITY_TYPES.EXHIBIT, selectedItems);

                return (
                  <Card
                    key={exhibit.id}
                    onClick={() => onSelect(exhibit)}
                    heading={exhibit.name}
                    footer={isMultiSite ? exhibit.zone.site.name : null}
                    imageUrl={exhibit.image?.preview_url}
                    active={selected}
                    disabled={isMaxSelected && !selected}
                  />
                )
              }) :
              <EmptyState />
            }
          </>
        }
      </PanelWrapper>
  );
}

export {ExhibitsPanel};